import { frontendURL } from 'dashboard/helper/URLHelper';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const FlowBuilderIndex = () => import('./Index.vue');
const FlowEditor = () => import('./FlowEditor.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/flow-builder'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'flow_builder_index',
          component: FlowBuilderIndex,
          meta: { permissions: ['administrator'] },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/flow-builder/new'),
      name: 'flow_builder_new',
      component: FlowEditor,
      meta: { permissions: ['administrator'] },
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/flow-builder/:flowId/edit'
      ),
      name: 'flow_builder_edit',
      component: FlowEditor,
      meta: { permissions: ['administrator'] },
    },
  ],
};
